import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { NewAccountRequest, CreateNewAccountRequestInput, UpdateNewAccountRequestInput } from '@aigftpwatch/shared';

export function useNewAccounts(status?: string, page = 1) {
  const params = new URLSearchParams({ page: String(page) });
  if (status) params.set('status', status);
  return useQuery({
    queryKey: ['new-accounts', status, page],
    queryFn: () => api.getPaginated<NewAccountRequest>(`/new-accounts?${params}`),
  });
}

export function useCreateNewAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateNewAccountRequestInput) => api.post<NewAccountRequest>('/new-accounts', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['new-accounts'] }),
  });
}

export function useUpdateNewAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: UpdateNewAccountRequestInput & { id: number }) =>
      api.put<NewAccountRequest>(`/new-accounts/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['new-accounts'] }),
  });
}

export function useSubmitNewAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post(`/new-accounts/${id}/submit`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['new-accounts'] }),
  });
}
